/**
 * Pré-carrega páginas de coleção ao passar o mouse/foco nos links do menu de categorias.
 */
(function () {
  const prefetched = new Set();

  function prefetchUrl(href) {
    if (!href || prefetched.has(href)) return;
    if (!href.includes('/collections/')) return;

    prefetched.add(href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  }

  function bind(link) {
    const href = link.getAttribute('href');
    if (!href || href === '#') return;

    const run = () => prefetchUrl(link.href);
    link.addEventListener('mouseenter', run, { passive: true });
    link.addEventListener('focus', run, { passive: true });
    link.addEventListener('touchstart', run, { passive: true });
  }

  function init() {
    document.querySelectorAll('.header-categories-nav__link[href*="/collections/"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
